import React, { useState } from 'react';
import { Tooltip, Button } from 'antd';
import {
  CopyOutlined,
  LikeOutlined,
  LikeFilled,
  DislikeOutlined,
  DislikeFilled,
  ReloadOutlined,
} from '@ant-design/icons';
import { copyText } from '../../utils/clipboard';
import { message as antdMessage } from 'antd';

/** Like / dislike / copy / optional regenerate (same as main Chat). */
export function MessageActions({ msg, onFeedback, onCopy, onRedo, isLast, showAlways, feedbackReadOnly }) {
  const [hovered, setHovered] = useState(false);
  const visible = showAlways || hovered || msg.feedback;

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        marginTop: 4,
        opacity: visible ? 1 : 0,
        transition: 'opacity 150ms ease',
        minHeight: 28,
      }}
    >
      {feedbackReadOnly && msg.feedback && (
        <span style={{ display: 'inline-flex', alignItems: 'center', lineHeight: 0 }} aria-hidden>
          {msg.feedback === 'like' ? (
            <LikeFilled style={{ color: '#10b981', fontSize: 14 }} />
          ) : (
            <DislikeFilled style={{ color: '#ef4444', fontSize: 14 }} />
          )}
        </span>
      )}
      {onFeedback && !feedbackReadOnly && (
        <>
          <Tooltip title="Like">
            <Button
              type="text"
              size="small"
              icon={msg.feedback === 'like' ? <LikeFilled style={{ color: '#10b981' }} /> : <LikeOutlined />}
              onClick={() => onFeedback(msg.feedback === 'like' ? null : 'like')}
              style={{ color: '#9ca3af', border: 'none', borderRadius: 6 }}
            />
          </Tooltip>
          <Tooltip title="Dislike">
            <Button
              type="text"
              size="small"
              icon={msg.feedback === 'dislike' ? <DislikeFilled style={{ color: '#ef4444' }} /> : <DislikeOutlined />}
              onClick={() => onFeedback(msg.feedback === 'dislike' ? null : 'dislike')}
              style={{ color: '#9ca3af', border: 'none', borderRadius: 6 }}
            />
          </Tooltip>
        </>
      )}
      <Tooltip title="Copy">
        <Button
          type="text"
          size="small"
          icon={<CopyOutlined />}
          onClick={onCopy}
          style={{ color: '#9ca3af', border: 'none', borderRadius: 6 }}
        />
      </Tooltip>
      {isLast && onRedo && (
        <Tooltip title="Regenerate">
          <Button
            type="text"
            size="small"
            icon={<ReloadOutlined />}
            onClick={onRedo}
            style={{ color: '#9ca3af', border: 'none', borderRadius: 6 }}
          />
        </Tooltip>
      )}
    </div>
  );
}

/** Copy-only row for read-only / admin transcript views. */
export function MessageCopyBar({ onCopy, style }) {
  return (
    <div onMouseEnter={() => {}} style={{ display: 'flex', alignItems: 'center', gap: 2, marginTop: 4, minHeight: 28, ...style }}>
      <Tooltip title="Copy">
        <Button
          type="text"
          size="small"
          icon={<CopyOutlined />}
          onClick={onCopy}
          style={{ color: '#9ca3af', border: 'none', borderRadius: 6 }}
        />
      </Tooltip>
    </div>
  );
}

export function copyMessageContent(content) {
  copyText(content || '');
  antdMessage.success('Copied', 1.5);
}
